import axios from '../../../../libs/axios'

export function getTariffList(tariffType: string, params: any) {
  const {rep, par, hs_ver = 'H4'} = params
  if (par) {
    return axios.get(`/get/tariff/${tariffType}/${rep}/${par}?v=${hs_ver}`)
  }
  return axios.get(`/get/tariff/${tariffType}/${rep}?v=${hs_ver}`)
}

export function getPrefTariffGroup(params: any) {
  const {code} = params
  return axios.get(`/get/tariff-group/${code}`)
}

export function getHSDescriptions(params: any) {
  const {hs_ver = 'H4', hs_codes = []} = params
  return axios.post(`/get/hs/descriptions/`, {hs_ver, hs_codes})
}

export function exportTemplate(axiosPrivate, type) {
  return axiosPrivate.get(`/master-data/export-template-tariff?type=${type}`, {
    responseType: 'blob',
  })
}

export function importDataTariff(axiosPrivate, formData) {
  return axiosPrivate.post('/master-data/import-tariff', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function getTariffByTypeAndID(axiosPrivate, type, params) {
  const { id } = params
  return axiosPrivate.get(`/tariff/${type}/${id}`)
}

export function updateTariffByTypeAndID(axiosPrivate, type, id, payload) {
  return axiosPrivate.put(`/tariff/${type}/${id}`, payload)
}

export function deleteTariffByTypeAndID(axiosPrivate, type, id) {
  return axiosPrivate.delete(`/tariff/${type}/${id}`)
}

export function createTariffByType(axiosPrivate, type, payload) {
  return axiosPrivate.post(`/tariff/${type}`, payload)
}
